import { ScriptDescriptionType, ScriptTypes } from '../../Types';
import BaseViewModel from '../../Models/BaseViewModel';
import { HostObject } from '../HostObject';
import { PathUtil } from '../Utils/PathUtil';
import { matchAll } from '../Utils/unsafe';

export class BaseScript {
	hostObject: HostObject;
	/** Исходный скрипт */
	Content?: string;
	/** Подготовленный скрипт */
	PreparedContent: string;
	contextElement: BaseViewModel;
	ScriptType: ScriptTypes;
	Message?: string;
	Purpose: string;
	LaunchCondition: BaseScript | null = null;

	// для "балансированных" скобок использовал http://stackoverflow.com/questions/546433/regular-expression-to-match-outer-brackets#answer-35271017
	// testing https://regex101.com/r/KZMLP4/1
	dynDepsRegex =
		/hostObject\.GetColItemValue\(((?:[^)(]+|\((?:[^)(]+|\([^)(]*\))*\))*)\)/g;

	constructor(
		contextElement: BaseViewModel,
		script: ScriptDescriptionType,
		scriptPurpose: string,
	) {
		this.contextElement = contextElement;
		this.ScriptType = script.ScriptType;
		this.Content = script.Content;
		if (script.Message) {
			this.Message = script.Message;
		}
		this.Purpose = scriptPurpose;
		this.hostObject = new HostObject(this.contextElement);

		// Тут будет контент скрипта
		let scriptContent = script.Content;
		// ежели скрипт есть
		if (script.Content && script.ScriptType === 'JavaScript') {
			scriptContent = '';
			// Проверяем нет ли в нем не объявленных переменных
			const unDefinedVars = checkScript(script.Content);
			if (unDefinedVars.length) {
				unDefinedVars.forEach((unDefinedVar) => {
					// Ежели есть, то объявим её, выведем предупреждение в консоль и объявим сами
					console.warn(
						`У элементе ${contextElement.FullPath} скрипт ${scriptPurpose} - не валиден! Переменная "${unDefinedVar}" не объявлена... Чиним.`,
					);
					const defineVar = 'let ' + unDefinedVar + ' = null; ';
					scriptContent = defineVar + script.Content;
				});
			} else {
				scriptContent = script.Content;
			}
		}
		this.PreparedContent = scriptContent;
	}

	canLaunchScript = () => {
		if (this.LaunchCondition) {
			const canLaunch: boolean = this.LaunchCondition.runScript();
			if (!canLaunch) {
				return false;
			}
		}
		return true;
	};
	runScript = (): any => {
		return null;
	};
	getDependentFields = (): Array<string> => {
		return [];
	};

	_dynArgsToRegexString = (args: string) => {
		const colIndexReplacement = '\\[.*?\\]';
		let regex = '';
		const splits = args.split(',');
		for (let i = 0; i < splits.length; i++) {
			const split = splits[i];
			// eslint-disable-next-line
			regex +=
				i % 2 === 1
					? colIndexReplacement + '.'
					: split.trim().replace('\s+', '').replace(/['"]+/g, '');
		}
		const fullPath = PathUtil.toAbsolutePath(
			regex,
			this.contextElement.FullPath,
		);
		return fullPath;
	};

	getDependentDynFieldRegexStrs = () => {
		if (!this.Content) {
			return [];
		}
		const matches = matchAll(this.Content, this.dynDepsRegex);
		if (matches) {
			return matches.map((item) => {
				return this._dynArgsToRegexString(item[1]);
			});
		}
		return [];
	};
}

/** Проверка скрипта на наличие не объявленных переменных. */
const checkScript = (scriptContent: string): string[] => {
	const list: string[] = [];
	// Ищем одиночные идентификаторы в конце строк
	const variableRegex = /\n\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*;?\s*$/gm;
	const varMatches = matchAll(scriptContent, variableRegex);
	const ignored = ['true', 'false', 'null', 'undefined', 'else', 'end'];
	if (varMatches && varMatches.length) {
		for (let index = 0; index < varMatches.length; index++) {
			const variableName = varMatches[index][1];
			if (ignored.includes(variableName)) {
				continue;
			}
			// Если переменная уже объявлена var/let/const — не добавляем дубликат
			const declareVarRegex = new RegExp(
				`\\bvar\\s+${variableName}\\b`,
				'm',
			);
			const declareLetRegex = new RegExp(
				`\\blet\\s+${variableName}\\b`,
				'm',
			);
			const declareConstRegex = new RegExp(
				`\\bconst\\s+${variableName}\\b`,
				'm',
			);
			if (!(
				declareVarRegex.test(scriptContent) ||
				declareLetRegex.test(scriptContent) ||
				declareConstRegex.test(scriptContent)
			)) {
				list.push(variableName);
			}
		}
	}
	return list;
};
